import { AbstractShape } from "../abstract/Shape";

export class ShapeRef {
    shape: AbstractShape | null | undefined = null;
    setShape(shape: AbstractShape | null | undefined = null){
        this.shape = shape;
    }

    getShape(){
        return this.shape;
    }
}